import CryptoJS from 'crypto-js';
import RaisedButton from 'material-ui/RaisedButton';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import '../../stylesheet/cardsummary.css';
import '../../stylesheet/tabdesign.css';
// import AuthNavbar from '../navigation/authnavigation.jsx'
import AdminNavbar from '../navigation/adminnavigation.jsx';



const mapStateToProps = state =>
({
    mobileNoInfoState: state.getMobileNoInfoReducer.mobileNoInfoState
})
const mapDispatchToProps = dispatch =>
({
    getMobileInfoDetails(mobileNo) {
        dispatch(
            actions.mobileNoInfoAction(mobileNo)
        )
    },
    getCardDetails(cardRefNo) {
        dispatch(
            actions.getCardDetailAction(cardRefNo)
        )
    },
})



class MobileNoDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileno: ''
        }


    }
    // static getDerivedStateFromProps(nextProps, prevState){
    //     
    //     
    //     if(nextProps.cardDetailState!==prevState.cardDetailState){
    //       return { cardDetailState: nextProps.cardDetailState};
    //    }
    //     else return null;
    //  }

    //  componentDidUpdate(prevProps, prevState) {
    //     if(prevProps.cardDetailState!==this.state.cardDetailState){
    //       //Perform some operation here
    //       this.setState({cardDetailState: cardDetailState});
    //     }
    //   }

    componentDidMount() {
        let user = localStorage.getItem('em')
        var bytes = CryptoJS.AES.decrypt(user.toString(), 'gmcabs123')
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);

        this.props.getMobileInfoDetails(plaintext)

    }

    handleSelect(cardReferenceId) {
        let _this = this
        localStorage.setItem('cardRefNumber', cardReferenceId)
        localStorage.setItem('cardSearchToast', 'first')
        this.props.getCardDetails(cardReferenceId)
        setTimeout(function () {
            if (localStorage.getItem('cardSearchToast') === 'second') {
                _this.props.history.push('/carddetails')
            }
        }, 3000)
    }

    render() {
        const { mobileNoInfoState } = this.props

        return (
            <div>
                <div className="col-sm-12">
                    <AdminNavbar />
                </div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="col-sm-12" style={{ marginTop: "100px" }}>
                    <span style={{ fontSize: "25px", fontWeight: "400" }}>
                        User Results
                    </span>
                </div>
                <div className="col-sm-11" style={{ marginLeft: "20px", marginTop: "20px" }}>
                    <div className="col-sm-12" style={{ padding: "0px" }}>
                        <div className="row">
                            {(mobileNoInfoState.status === 200) ?
                                mobileNoInfoState.body.length !== 0 && mobileNoInfoState.body.map((value, i) =>
                                    <div className="col-sm-4">

                                        <div className="col-sm-12">
                                            <table className="table table-active table-striped" style={{ marginLeft: "20px", marginTop: "15px" }}>
                                                <thead className="thead-dark">
                                                    <tr style={{ fontSize: "11px" }}>
                                                        <th scope="col" colspan="2" style={{ padding: "10px", textAlign: "center", fontSize: "15px" }}>Cardholder Information</th>

                                                    </tr>
                                                </thead>

                                                <tbody id="myTable" style={{ fontSize: "15px" }}>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>User Name:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].userName}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Card Number:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].cardNumber}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Card Ref. Number:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].cardReferenceId}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Card Status:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].portalCardStatus}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Card Status in I-Choose:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].cardStatus}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Name:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].firstName} {mobileNoInfoState.body[i].lastName}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Date of Birth:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].dateofbirth}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Address:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].address} {mobileNoInfoState.body[i].address2}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>City:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].city}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>State:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].state}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Zip/Post Code:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].pincode}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Country:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].country}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Secret Question:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].secretQuestion}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Answer:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].secretAnswer}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Home Phone Number:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].homePhoneNumber}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Mobile Number:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].mobileNumber}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Email:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {mobileNoInfoState.body[i].emailId}</td>

                                                    </tr>

                                                </tbody>


                                            </table>
                                        </div>
                                        <div className=" offset-5 col-sm-7">
                                            <RaisedButton
                                                label="Select"
                                                // buttonStyle={styles.buttonStyle}
                                                // labelColor="#fff"
                                                className="btn-std"
                                                backgroundColor="#FFCE39"
                                                labelColor="#115876"
                                                onClick={() => { this.handleSelect(mobileNoInfoState.body[i].cardReferenceId) }}
                                                disabled={this.state.disabled}
                                            />
                                        </div>
                                    </div>
                                )
                                :
                                <div></div>

                            }


                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileNoDetails); 


// WEBPACK FOOTER //
// ./src/components/adminuser/mobnodetails.jsx